module.exports = __webpack_public_path__ + "img/hylb.68818e85.png";